import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface RainIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const RainIcon = observer('RainIcon', ({ className, onClick }: RainIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='currentcolor'
            height='32'
            onClick={onClick}
            viewBox='0 0 32 32'
            width='32'
            xmlns='http://www.w3.org/2000/svg'
            data-test='weather-icon'
        >
            <path
                fill='fill'
                fillRule='evenodd'
                d='M24 23.957c3.375-.387 6-3.354 6-6.957 0-3.866-3.022-7-6.75-7-.145 0-.287.005-.429.014C21.566 5.39 17.469 2 12.608 2 6.75 2 2 6.925 2 13c0 5.142 3.402 9.46 8 10.665v-2.088C6.553 20.43 4 17.066 4 13c0-5.04 3.922-9 8.608-9 3.976 0 7.401 2.85 8.349 6.791l.003-.001c.134.547.22 1.114.25 1.696A4.54 4.54 0 0 1 23.25 12c2.555 0 4.75 2.17 4.75 5 0 2.549-1.78 4.561-4 4.937v2.02Zm-10.498 4.045c.242 0 .5-.21.5-.546 0-.184-.063-.53-.259-1.04a8.774 8.774 0 0 0-.269-.622c-.299.65-.473 1.234-.472 1.662 0 .336.258.546.5.546Zm-1.21-4.245C12.902 22.73 13.5 22 13.5 22s.57.755 1.165 1.778c.653 1.12 1.337 2.56 1.337 3.678 0 1.406-1.118 2.546-2.5 2.546-1.38 0-2.5-1.14-2.5-2.546 0-1.227.652-2.625 1.29-3.699Zm7.71.699c0 .336-.258.546-.5.546s-.5-.21-.5-.546c0-.428.173-1.012.472-1.662.1.21.192.42.27.623.195.51.258.855.258 1.039ZM19.5 19s-.597.73-1.208 1.757c-.638 1.074-1.29 2.472-1.29 3.699 0 1.406 1.12 2.546 2.5 2.546 1.382 0 2.5-1.14 2.5-2.546 0-1.118-.684-2.558-1.336-3.678A19.973 19.973 0 0 0 19.5 19Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
